import { Share, SquarePlus, X } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { isIos, isStandalone } from "@/lib/push.ts";
import { LogoMark } from "./Logo.tsx";

const DISMISS_KEY = "codvero.installHint.dismissed";


/** iPhone/iPad: Safari has no install button, so explain "Share → Add to Home Screen" (needed for notifications on iOS). */
export function InstallHint({ always = false }: { always?: boolean }) {
  const { t } = useTranslation();
  const [hidden, setHidden] = useState(() => {
    try { return !always && localStorage.getItem(DISMISS_KEY) === "1"; } catch { return false; }
  });
  if (hidden || !isIos() || isStandalone()) return null;
  return (
    <div className="flex items-start gap-3 rounded-lg border border-accent/40 bg-accent-soft/30 p-3 text-sm">
      <LogoMark size={36} />
      <div className="min-w-0 flex-1 space-y-1">
        <div className="font-medium">{t("install.title")}</div>
        <p className="text-xs text-fg-muted">{t("install.why")}</p>
        <ol className="list-decimal space-y-0.5 ps-5 text-xs">
          <li className="flex-wrap">{t("install.step1")} <Share className="inline size-3.5 align-text-bottom" /></li>
          <li>{t("install.step2")} <SquarePlus className="inline size-3.5 align-text-bottom" /></li>
        </ol>
      </div>
      {!always && (
        <button type="button" aria-label={t("common.close")} className="tap grid place-items-center rounded-md text-fg-muted hover:text-fg" onClick={() => { setHidden(true); try { localStorage.setItem(DISMISS_KEY, "1"); } catch { /* ignore */ } }}>
          <X className="size-4" />
        </button>
      )}
    </div>
  );
}
